import { PadCollapse } from 'app/shared/components/misc';
import styledFuncs from 'app/styles/styledFuncs';
import styled from 'styled-components/macro';
import IconLib, {
  PaperTick,
} from 'app/shared/components/icon/icon-lib';
import React, { useState } from 'react';
import Button from 'app/shared/components/button/Button';
import Icon from 'app/shared/components/icon/Icon';
import { Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ConsumerRoutePath from 'app/consumer-app/ConsumerRoutePath';
import { IdentityPlus } from 'app/core/api/user/api-user.types';
import { useHistory } from 'react-router-dom';
import Body from '../../../shared/components/typography/body/Body';
import bike from '../../../../assets/bike.png';

// type Props = {
//   isWelcomeDrawerOpen: boolean;
//   setIsWelcomeDrawerOpen: (isVisible: boolean) => unknown;
// };
const DetailsTitle = styled('h3')`
  font-weight: 500;
  font-size: 15px;
`;
const DetailsContent = styled('p')`
  font-weight: 400;
  font-size: 15px;
`;
const DetailsContainer = styled('div')`
  width: 100px;
  text-align: center;
  margin: auto 0;
`;
const PageTitle = styled(Body)`
  font-size: 30px;
  font-weight: 500;
  margin: 0 ${styledFuncs.pad(2)};
`;
const PageTitleGreen = styled(Body)`
  font-size: 30px;
  font-weight: 600;
  color: #31ad31;
  margin: 0 ${styledFuncs.pad(2)};
`;
const useStyles = makeStyles({
  drawerPaper: {
    maxHeight: '75%',
    borderRadius: '10px 10px 0 0',
    margin: '0 auto',
    maxWidth: '500px',
  },
});
type Props = {
  identity: IdentityPlus | undefined;
  isWelcomeDrawerOpen: boolean;
  setIsWelcomeDrawerOpen: (isVisible: boolean) => unknown;
};
export default function WelcomeDrawer({
  identity,
  isWelcomeDrawerOpen,
  setIsWelcomeDrawerOpen,
}: Props): JSX.Element {
  const classes = useStyles();
  const history = useHistory();
  const [isCompetitionDrawerOpen, setIsCompetitionDrawerOpen] =
    useState(false);
  return (
    <>
      <Drawer
        variant="persistent"
        anchor="bottom"
        open={isWelcomeDrawerOpen}
        onClose={() => setIsWelcomeDrawerOpen(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <PadCollapse pad={2} />
        <PageTitle style={{ textAlign: 'left' }}>
          Welcome to
        </PageTitle>
        <PageTitleGreen style={{ textAlign: 'left' }}>
          iWarranty!
        </PageTitleGreen>
        <PadCollapse pad={2} />
        <div style={{ margin: '0 auto' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
            }}
          >
            <DetailsContainer>
              <PaperTick
                style={{
                  height: '30px',
                }}
              />
            </DetailsContainer>
            <div style={{ width: '65%' }}>
              <DetailsTitle>
                Warranties at your fingertips
              </DetailsTitle>
              <DetailsContent>
                No more fine print, we summarise the important parts
                for you.
              </DetailsContent>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
            }}
          >
            <DetailsContainer>
              <Icon
                icon={IconLib.SHIELD_TICK}
                size={35}
                color="#31ad31"
              />
            </DetailsContainer>
            <div style={{ width: '65%' }}>
              <DetailsTitle>
                Access the Green Repair Network
              </DetailsTitle>
              <DetailsContent>
                Instantly connect with local and authorised repairers
                around you. <br />
                Repair. Reuse. Reduce.
              </DetailsContent>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
            }}
          >
            <DetailsContainer>
              <Icon
                icon={IconLib.NEW_PAGE}
                size={35}
                color="#31ad31"
              />
            </DetailsContainer>
            <div style={{ width: '65%' }}>
              <DetailsTitle>Peace of mind</DetailsTitle>
              <DetailsContent>
                Upload your products and keep track of your warranties
                and receipts in one place.
              </DetailsContent>
            </div>
          </div>
        </div>
        {identity?.isPartOfCompetition && (
          <Button
            variant="outlined"
            style={{ width: '285px', margin: '20px auto' }}
            onClick={() => {
              setIsCompetitionDrawerOpen(true);
            }}
          >
            Next
          </Button>
        )}
        {!identity?.isPartOfCompetition && (
          <Button
            variant="outlined"
            style={{ width: '285px', margin: '20px auto' }}
            to={ConsumerRoutePath.PRODUCT_SEARCH_CATALOG}
            onClick={() => {
              setIsWelcomeDrawerOpen(false);
            }}
          >
            Next
          </Button>
        )}
      </Drawer>
      <Drawer
        anchor="bottom"
        open={isCompetitionDrawerOpen}
        onClose={() => setIsCompetitionDrawerOpen(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <PadCollapse pad={2} />
        <div
          style={{
            width: '75%',
            margin: '0 20px',
            color: '#6abc35',
          }}
        >
          <DetailsTitle>Win a Super Soco TC</DetailsTitle>
        </div>
        <PageTitle style={{ textAlign: 'left' }}>
          Enter the Competition
        </PageTitle>
        <PageTitleGreen>Motorcycle Live</PageTitleGreen>
        <PadCollapse pad={0} />
        <div
          style={{
            display: 'flex',
            alignItems: 'stretch',
          }}
        >
          <div style={{ margin: '0 20px', color: 'red' }}>
            <DetailsTitle>
              Available from 12 Nov 2022 to 11 Dec 2022*
            </DetailsTitle>
          </div>
        </div>
        <img
          src={bike}
          alt="Bike"
          style={{
            height: '200px',
            width: '200px',
            margin: '0 auto',
          }}
        />
        <div style={{ margin: '0 auto' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
            }}
          >
            <DetailsContainer>
              <Icon
                icon={IconLib.NEW_PAGE}
                size={35}
                color="#31ad31"
              />
            </DetailsContainer>
            <div style={{ width: '65%' }}>
              <DetailsTitle>Upload 3 products</DetailsTitle>
              <DetailsContent>
                For a chance to win a Super Soco TC
              </DetailsContent>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
            }}
          >
            <DetailsContainer>
              <Icon icon={IconLib.SEND} size={35} color="#31ad31" />
            </DetailsContainer>
            <div style={{ width: '65%' }}>
              <DetailsTitle>Refer a Friend</DetailsTitle>
              <DetailsContent>
                Refer a friend for an additional chance to enter the
                competition
              </DetailsContent>
            </div>
          </div>
        </div>
        <Button
          variant="outlined"
          style={{ width: '285px', margin: '10px auto' }}
          to={ConsumerRoutePath.PRODUCT_SEARCH_CATALOG}
          onClick={() => {
            setIsWelcomeDrawerOpen(false);
          }}
        >
          Let's get started!
        </Button>
        <text
          style={{
            margin: '0 auto 10px auto',
            fontSize: '11px',
            color: 'red',
          }}
          cursor="pointer"
          onClick={() =>
            history.push(`${ConsumerRoutePath.COMPETITION_TERMS}`)
          }
        >
          *Terms & Conditions apply
        </text>
      </Drawer>
    </>
  );
}
